import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, Hash } from 'lucide-react';
import { useJoinRoom } from './api';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { Input, Label, FieldError, FieldHint } from '@/components/ui/Input';
import { useToast } from '@/components/ui/Toast';
const errorMessages = {
    room_not_found: 'Aucune room avec ce code.',
    room_closed: 'Cette room est fermée.',
    room_full: 'La room est pleine.',
    not_host: "Tu n'es pas l'hôte.",
    auth_required: 'Connecte-toi pour rejoindre.',
    unknown: 'Erreur inattendue.',
};
const VALID_CODE = /^[ABCDEFGHJKMNPQRSTUVWXYZ23456789]{6}$/;
export function JoinByCodeModal({ open, onOpenChange }) {
    const [code, setCode] = useState('');
    const [error, setError] = useState(null);
    const { mutateAsync, isPending } = useJoinRoom();
    const navigate = useNavigate();
    const { toast } = useToast();
    async function onSubmit(e) {
        e.preventDefault();
        setError(null);
        const upper = code.trim().toUpperCase();
        if (!VALID_CODE.test(upper)) {
            setError('Le code fait 6 caractères (A-Z hors O/I/L, chiffres hors 0/1).');
            return;
        }
        try {
            await mutateAsync(upper);
            onOpenChange(false);
            setCode('');
            navigate(`/lobby/${upper}`);
        }
        catch (err) {
            const c = err?.code ?? 'unknown';
            setError(errorMessages[c]);
            toast({ tone: 'error', title: 'Impossible de rejoindre', description: errorMessages[c] });
        }
    }
    return (_jsx(Modal, { open: open, onOpenChange: (o) => {
            onOpenChange(o);
            if (!o) {
                setCode('');
                setError(null);
            }
        }, title: _jsxs("span", { className: "inline-flex items-center gap-2", children: [_jsx(LogIn, { className: "h-5 w-5 text-flame-400" }), "Rejoindre par code"] }), description: "Demande son code \u00E0 l'h\u00F4te (6 caract\u00E8res).", footer: _jsxs(_Fragment, { children: [_jsx(Button, { variant: "ghost", onClick: () => onOpenChange(false), children: "Annuler" }), _jsx(Button, { variant: "primary", form: "join-room-form", type: "submit", isLoading: isPending, children: "Rejoindre" })] }), children: _jsxs("form", { id: "join-room-form", onSubmit: (e) => void onSubmit(e), className: "space-y-2", children: [_jsx(Label, { htmlFor: "join-code", required: true, children: "Code de la room" }), _jsx(Input, { id: "join-code", autoFocus: true, value: code, onChange: (e) => setCode(e.target.value.toUpperCase().slice(0, 6)), placeholder: "ABCDEF", maxLength: 6, invalid: !!error, leftIcon: _jsx(Hash, { className: "h-4 w-4" }), className: "text-center font-mono uppercase tracking-[0.5em]" }), error ? _jsx(FieldError, { children: error }) : _jsx(FieldHint, { children: "Le code n'est pas sensible \u00E0 la casse." })] }) }));
}
